import {DefaultValue, selector, selectorFamily} from 'recoil';

import {DictionaryService} from '../../api/services/dictionary.service';
import {
  currentreasonRejectionCodeState,
  currentreasonRejectionState,
  reasonRejectionsDictQueryByCodeTrigger,
  reasonRejectionsDictQueryTrigger,
  reasonRejectionsMapWithNamesState,
  reasonRejectionsState,
} from './atoms';

export const reasonRejectionsDictQuery = selector({
  key: 'reasonRejectionsDictQuery',
  get: async ({get}) => {
    get(reasonRejectionsDictQueryTrigger);
    const res = await DictionaryService.getAllReasonRejections();

    return res.data;
  },

  set: ({set, get}, newValue) => {
    if (newValue) {
      set(reasonRejectionsState, newValue);

      if (newValue && !(newValue instanceof DefaultValue) && newValue.content?.length > 0) {
        const mapWithNames = get(reasonRejectionsMapWithNamesState);

        newValue.content.forEach((i) => {
          mapWithNames.set(i.code, i.name);
          mapWithNames.set(i.name?.toLowerCase(), i.code);
        });
      }
    }
  },
});

export const reasonRejectionDictQueryByCode = selector({
  key: 'reasonRejectionDictQueryByCode',
  get: async ({get}) => {
    const code = get(currentreasonRejectionCodeState);

    if (!code) return null;

    const res = await DictionaryService.getReasonRejectionByCode(String(code));

    return res.data;
  },

  set: ({set}, newValue) => {
    set(currentreasonRejectionState, newValue);
  },
});

export const reasonRejectionDictQueryByCodeFamily = selectorFamily({
  key: 'reasonRejectionDictQueryByCodeFamily',
  get:
    (code) =>
    async ({get}) => {
      get(reasonRejectionsDictQueryByCodeTrigger);

      const res = await DictionaryService.getReasonRejectionByCode(String(code));

      return res.data;
    },

  set:
    (code) =>
    ({set}, newValue) => {
      set(currentreasonRejectionState, newValue);
    },
});

export const reasonRejectionMapWithNamesSelector = selector({
  key: 'reasonRejectionMapWithNamesSelector',
  get: ({get}) => {
    const {content: reasonRejections} = get(reasonRejectionsState);

    const mapWithNames = new Map<string, string>();

    reasonRejections.length > 0 &&
      reasonRejections.forEach((i) => {
        mapWithNames.set(i.code, i.name);
      });

    return mapWithNames;
  },
});
